import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { GOOGLE_PLACES_SESSION_KEY } from "../constants";

const getSearchResults = async ({ sessionToken, search }) => {
    const params = new URLSearchParams({
        search,
        "session-token": sessionToken,
    });

    return axios
        .get(`/wp-json/api/adpt/search?${params.toString()}`)
        .then((res) => res?.data);
};

export default function useSearchResults({ search }) {
    let sessionToken = window.sessionStorage.getItem(GOOGLE_PLACES_SESSION_KEY);

    if (!sessionToken) {
        const token = uuid();

        window.sessionStorage.setItem(GOOGLE_PLACES_SESSION_KEY, token);
        sessionToken = token;
    }

    return useQuery(
        ["search", { search }],
        () => getSearchResults({ sessionToken, search }),
        {
            enabled: !!search,
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
        }
    );
}
